module.exports = __webpack_public_path__ + "static/img/Henry.Slattery.5674151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Henry.Slattery.jpg
// module id = q+F5
// module chunks = 0